import { RoleName } from 'api/user';

export const userRoles = [
  { value: 1, label: RoleName.ADMIN },
  { value: 2, label: RoleName.ASO1 },
  { value: 3, label: RoleName.ASO2 },
];
